export const DATA_LIMIT = 10;

export const PINTEREST_PIN_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: ''},
    {attribute: "title", label: "Title", cssClass: ''},
    {attribute: "boardId", label: "Board Id", cssClass: ''},
    {attribute: "boardSectionId", label: "Board Section Id", cssClass: ''},
    {attribute: "productTags", label: "Product Tags", cssClass: ''},
    {attribute: "link", label: "Link", cssClass: ''},
    {attribute: "altText", label: "Alt Text", cssClass: ''},
    {attribute: "dominantColor", label: "Dominant Color", cssClass: ''},
    {attribute: "isStandard", label: "Is Standard", cssClass: ''},
    {attribute: "creativeType", label: "Creative Type", cssClass: ''},
    {attribute: "isOwner", label: "Is Owner", cssClass: ''},
    {attribute: "description", label: "Description", cssClass: ''},
    {attribute: "parentPinId", label: "Parent Pin Id", cssClass: ''},
];


export const PINTEREST_PIN_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "title", label: "Title", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "boardId", label: "Board Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "boardSectionId", label: "Board Section Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "productTags", label: "Product Tags", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "link", label: "Link", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "altText", label: "Alt Text", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "dominantColor", label: "Dominant Color", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "isStandard", label: "Is Standard", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "creativeType", label: "Creative Type", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "isOwner", label: "Is Owner", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "description", label: "Description", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "parentPinId", label: "Parent Pin Id", type: 'text', group: 'detail', cssClass: ''},
];
